import React from 'react';

interface SignOutProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const SignOut: React.FC<SignOutProps> = ({ width = 16, height = 16, className, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" className={className} style={style}>
      <path
        d="M6 14H4a2 2 0 01-2-2V4a2 2 0 012-2h2M10 11l3-3-3-3M13 8H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SignOut;
